// Thin typed wrapper around the parameterised reviewable endpoints
// (`/api/agent/reviewables/:kind/:id/{approve,reject,request-revision}`)
// that supersede the named-action handlers in
// apps/server/src/lib/db/actions/{desk,agent-triggers}.ts (OLD_CODE.html
// #2). Lets call sites configure work in terms of `{ kind, verb }` instead
// of a string like `'approve-call-extracted-fact'`, so the wire surface
// stays typed and the kebab-case action-name parsing disappears.

import type { ReviewableKind } from '@septima/contract';

import { api, runStaffEndpoint } from './api';
import type { StaffActionResult } from '@septima/contract';

export async function approveReviewable(
    kind: ReviewableKind,
    id: string,
    extra: Record<string, unknown> = {},
): Promise<StaffActionResult> {
    return runStaffEndpoint(
        api.agent.approveReviewable({
            params: { kind, id },
            body: extra,
        }),
    );
}

export async function rejectReviewable(
    kind: ReviewableKind,
    id: string,
    reason?: string,
): Promise<StaffActionResult> {
    return runStaffEndpoint(
        api.agent.rejectReviewable({
            params: { kind, id },
            body: { reason },
        }),
    );
}

export async function requestRevisionReviewable(
    kind: ReviewableKind,
    id: string,
    revisionReason: string,
): Promise<StaffActionResult> {
    return runStaffEndpoint(
        api.agent.requestRevisionReviewable({
            params: { kind, id },
            body: { revisionReason: revisionReason },
        }),
    );
}
